export var removeDuplicates = function (array) {
    if (array == null)
        return [];
    return array.filter(function (item, index) { return array.indexOf(item) === index; });
};
